import $ from 'jquery';

$( document ).on('turbolinks:load', function() {
    $(".categories-cards .trigger-collapse").click(function(e) {
        let $content = jQuery(this).closest('.card').find('.card-collapse-content');

        $(this).toggleClass('is-visible');
        $content.slideToggle('is-visible');
    });
});